import { render, staticRenderFns } from "./TemperatureSetting2.vue?vue&type=template&id=76224714&scoped=true"
import script from "./TemperatureSetting2.vue?vue&type=script&lang=js"
export * from "./TemperatureSetting2.vue?vue&type=script&lang=js"
import style0 from "./TemperatureSetting2.vue?vue&type=style&index=0&id=76224714&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76224714",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/votech/Documents/project/web/wave-writer-joecig/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76224714')) {
      api.createRecord('76224714', component.options)
    } else {
      api.reload('76224714', component.options)
    }
    module.hot.accept("./TemperatureSetting2.vue?vue&type=template&id=76224714&scoped=true", function () {
      api.rerender('76224714', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TemperatureSetting2.vue"
export default component.exports